import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

interface ConfigInterface {
    contribution: {
        min: number;
    };
    domain: string;
    gtmId: string;
    language: string;
    logaltyUrl: string;
    portalClientUrl: string;
    reCaptchaKey: string;
    services: {
        base: string;
    };
    campaign: {
        startAt: string;
        endAt: string;
        textCampaign: string;
        urlCampaign: string;
    };
    initialContribution: {
        min: number;
    };
    tae_url: string;
}

@Injectable()
export class AppConfig {
    static settings: ConfigInterface;

    constructor(private http: HttpClient) {}

    load(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.http.get(environment.baseHref + 'assets/config.json?v=' + environment.version).subscribe(
                (config: ConfigInterface) => {
                    AppConfig.settings = config as ConfigInterface;
                    resolve();
                },
                (err) => {
                    reject('Could not load the config file');
                }
            );
        });
    }
}
